module.exports = __webpack_public_path__ + "media/35.e321d93c.wav";